import React from "react";
import TVSub from "../../Component/Products/tv-subscriptions";

const MainTvSub = () => {
	return <TVSub />;
};

export default MainTvSub;
